import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { pc, minSp } from "components/mixins/mediaQuery";

const ModuleArea: React.FC = ({ children }) => {
  const rightSectionOpen = useSelector(
    (state: any) => state.sidebar.rightSectionOpen
  );
  return (
    <ModuleAreaColumn className={rightSectionOpen ? "open" : "close"}>
      {children}
    </ModuleAreaColumn>
  );
};

export default ModuleArea;

const ModuleAreaColumn = styled.div`
  flex-direction: column;
  width: 100%;
  order: 1;
  ${minSp`
    order: 1;
    display: none;
  `}
  ${pc`
    max-width: 360px;
    order: 2;
    display: flex;
    &.close {
      display: none;
    }
  `}
`;
